/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/**
 * #16972 – Round product prices to the nearest dollar (no trailing decimals),
 * matching compare-at display (e.g. $170) for discounted/sale prices too.
 */
(function () {
  function roundCurrencyNode(el) {
    if (!el || el.nodeType !== 1) return;

    var text = (el.textContent || '').trim();
    if (!text) return;

    // e.g. $67.50, $1,234.50, $81
    var match = text.match(/^(\$\s?)([\d,]+)(?:\.(\d+))?$/);
    if (!match) return;

    var whole = match[2].replace(/,/g, '');
    var cents = match[3] || '0';
    var value = parseFloat(whole + '.' + cents);
    if (isNaN(value)) return;

    var rounded = Math.round(value);
    var next = match[1].replace(/\s/g, '') + rounded;

    if (el.textContent.trim() !== next) {
      el.textContent = next;
    }
  }

  function roundBoostPrices(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(
      '.boost-sd__format-currency, .boost-sd__product-price .boost-sd__format-currency'
    );

    // If root itself matches, include it
    if (root && root.matches && root.matches('.boost-sd__format-currency')) {
      roundCurrencyNode(root);
    }

    nodes.forEach(roundCurrencyNode);
  }

  function afterRender() {
    roundBoostPrices(document);
  }

  function registerBoostCustomization() {
    if (
      typeof window.boostWidgetIntegration !== 'undefined' &&
      typeof window.boostWidgetIntegration.regisCustomization === 'function'
    ) {
      window.boostWidgetIntegration.regisCustomization(afterRender, 'filter');
      return true;
    }
    return false;
  }

  // Observe Boost re-renders that replace price nodes
  function observePrices() {
    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.boost-sd__format-currency')) {
              roundCurrencyNode(node);
            } else if (node.querySelectorAll) {
              roundBoostPrices(node);
            }
          });
        } else if (
          mutation.type === 'characterData' &&
          mutation.target &&
          mutation.target.parentElement
        ) {
          var parent = mutation.target.parentElement.closest(
            '.boost-sd__format-currency'
          );
          if (parent) roundCurrencyNode(parent);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    afterRender();
    observePrices();

    if (!registerBoostCustomization()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (registerBoostCustomization() || tries > 40) {
          clearInterval(timer);
          afterRender();
        }
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
